export default __webpack_public_path__ + "paddle_energy_hoverafc5e7.svg";